// STORES ALL CONSTANTS

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '677f3c1a-acff-48e9-83db-9359c2df21e6';
